/*
 **	Simple Monochrome Icons for iOS-style Interface
 **	OMNI_IQ Mobile (c) 2025 Silver Falls Capital. All Rights Reserved
 */

import React from 'react'
import { OCAColors } from '../../theme/colors'

interface IconProps {
  size?: number
  color?: string
  backgroundColor?: string
}

export const DeviceIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = OCAColors.background, 
  backgroundColor = OCAColors.primary 
}) => (
  <div style={{
    width: size + 16,
    height: size + 16,
    borderRadius: (size + 16) / 2,
    backgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="4" y="4" width="16" height="12" rx="2" stroke={color} strokeWidth="2"/>
      <rect x="6" y="6" width="12" height="8" rx="1" fill={color}/>
      <circle cx="12" cy="10" r="2" fill={backgroundColor}/>
    </svg>
  </div>
)

export const LocationIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = OCAColors.background, 
  backgroundColor = '#007AFF' 
}) => (
  <div style={{
    width: size + 16,
    height: size + 16,
    borderRadius: (size + 16) / 2,
    backgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill={color}/>
      <circle cx="12" cy="9" r="3" fill={backgroundColor}/>
    </svg>
  </div>
)

export const AlarmIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = OCAColors.background, 
  backgroundColor = '#FF3B30' 
}) => (
  <div style={{
    width: size + 16,
    height: size + 16,
    borderRadius: (size + 16) / 2,
    backgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" fill={color}/>
      <circle cx="12" cy="19" r="2" fill={color}/>
    </svg>
  </div>
)

export const SettingsIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = OCAColors.background, 
  backgroundColor = '#8E8E93' 
}) => (
  <div style={{
    width: size + 16,
    height: size + 16,
    borderRadius: (size + 16) / 2,
    backgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" fill={color}/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" stroke={color} strokeWidth="1.5"/>
    </svg>
  </div>
)

export const ProfileIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = OCAColors.background, 
  backgroundColor = '#34C759' 
}) => (
  <div style={{
    width: size + 16,
    height: size + 16,
    borderRadius: (size + 16) / 2,
    backgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke={color} strokeWidth="2"/>
      <circle cx="12" cy="7" r="4" fill={color}/>
    </svg>
  </div>
)

export const ChevronRightIcon: React.FC<{ color?: string }> = ({ 
  color = OCAColors.tertiaryLabel 
}) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M9 18l6-6-6-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)